var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    {
      ref: "data-container",
      staticStyle: { position: "relative", height: "100%", width: "100%" },
      on: {
        "!focus": function ($event) {
          return _vm.updateFocus($event)
        },
        dblclick: function ($event) {
          return _vm.doubleClick($event)
        },
        change: function ($event) {
          return _vm.updateInput($event)
        },
        contextmenu: function ($event) {
          $event.preventDefault()
          return _vm.showContextMenu.apply(null, arguments)
        },
      },
    },
    [
      _vm.isTenantAdmin
        ? _c(
            "v-menu",
            {
              attrs: {
                "position-x": _vm.contextMenu.x,
                "position-y": _vm.contextMenu.y,
                absolute: "",
                "offset-y": "",
              },
              model: {
                value: _vm.contextMenu.show,
                callback: function ($$v) {
                  _vm.$set(_vm.contextMenu, "show", $$v)
                },
                expression: "contextMenu.show",
              },
            },
            [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.contextMenu.items, function (item, index) {
                    return [
                      item.divider
                        ? _c("v-divider", { key: `divider-${index}` })
                        : _c(
                            "v-list-tile",
                            {
                              key: `contextMenu-${index}`,
                              attrs: { disabled: item.disabled },
                              on: {
                                click: function ($event) {
                                  return _vm.contextMenuAction(item)
                                },
                              },
                            },
                            [
                              item.icon
                                ? _c(
                                    "v-list-tile-avatar",
                                    [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(item.title)),
                              ]),
                            ],
                            1
                          ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-flex", [
        _c(
          "div",
          { staticClass: "rowHeaderCollection" },
          [
            _vm.isInitialized
              ? _c("VirtualCollection", {
                  ref: "rowHeaderCollection",
                  attrs: {
                    cellSizeAndPositionGetter:
                      _vm.rowHeaderSizeAndPositionGetter,
                    collection: _vm.rowHeaders,
                    height: _vm.containerHeight,
                    width: _vm.WIDTH_PADDING,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell",
                        fn: function (props) {
                          return _c(
                            "div",
                            {
                              staticClass: "rowHeader unselectable",
                              class: _vm.isSelectedRowHeader(
                                props.data.value,
                                _vm.selectedLocation
                              ),
                              attrs: { id: `rowHeader-${props.data.value}` },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(props.data.text) +
                                  "\n        "
                              ),
                            ]
                          )
                        },
                      },
                    ],
                    null,
                    false,
                    2877322541
                  ),
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "div",
            { staticClass: "columnHeaderCollection" },
            [
              _c("div", { ref: "scrollCover", staticClass: "scroll-cover" }),
              _vm._v(" "),
              _vm.isInitialized
                ? _c("VirtualCollection", {
                    ref: "columnHeaderCollection",
                    attrs: {
                      cellSizeAndPositionGetter:
                        _vm.columnHeaderSizeAndPositionGetter,
                      collection: _vm.columnHeaders,
                      height: _vm.HEIGHT_PADDING,
                      width: _vm.containerWidth,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell",
                          fn: function (props) {
                            return _c(
                              "div",
                              {
                                staticClass: "columnHeader unselectable",
                                class: _vm.isSelectedColumnHeader(
                                  props.data.value,
                                  _vm.selectedLocation
                                ),
                                attrs: {
                                  id: `columnHeader-${props.data.value}`,
                                },
                              },
                              [_vm._v(_vm._s(props.data.text))]
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      464207985
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isInitialized
            ? _c("VirtualCollection", {
                ref: "cellCollection",
                attrs: {
                  cellSizeAndPositionGetter: _vm.cellSizeAndPositionGetter,
                  collection: _vm.data,
                  height: _vm.containerHeight,
                  width: _vm.containerWidth,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell",
                      fn: function (props) {
                        return _c(
                          "div",
                          {
                            staticClass: "cell lighten-2",
                            class: [
                              _vm.getMainClass(
                                props.data.location,
                                _vm.updatedToggle
                              ),
                              _vm.isDirty(props.data) ? "dirty" : "",
                              _vm.isDeletedClass(props.data.location)
                                ? "deleted"
                                : "",
                            ],
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.lazy",
                                  value: props.data.value,
                                  expression: "props.data.value",
                                  modifiers: { lazy: true },
                                },
                              ],
                              class: [
                                _vm.isSelectedCell(
                                  props.data.location,
                                  _vm.selectedLocation
                                ),
                              ],
                              attrs: { id: `cell-${props.data.location}` },
                              domProps: { value: props.data.value },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    props.data,
                                    "value",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.getSideClasses(
                                props.data.location,
                                _vm.updatedToggle
                              ),
                              function (sideClass, index) {
                                return _c(
                                  "v-icon",
                                  {
                                    key: `sideClass-${index}`,
                                    staticClass: "bubble",
                                    style: _vm.getBubblePadding(index),
                                    attrs: { color: `${sideClass} lighten-2` },
                                  },
                                  [_vm._v("brightness_1")]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  1544943339
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }